<template>
	<el-menu class="el-menu-vertical" unique-opened :default-active="pathRouter" 
	@select="handleSelect" @open="handleOpen" @close="handleClose" 
	:collapse="isCollapse" style="heigh:500px;">
		<el-menu-item index="changeCollapse" class="collapse">
			<i :class="{ 'el-icon-s-fold': !isCollapse, 'el-icon-s-unfold': isCollapse }"></i>
		</el-menu-item>
		<el-menu-item index="index">
			<i class="el-icon-monitor"></i>
			<span slot="title">首页</span>
		</el-menu-item>
		<template v-for="menu in tree">
			<template v-if="!menu.children && menu.name.indexOf('_gmqm') > -1">
				<el-menu-item v-bind:index="menu.name" v-bind:key="menu.id">
					<i v-bind:class="menu.meta.icon"></i>
					<span slot="title" v-text="menu.meta.title"></span>
				</el-menu-item>
			</template>
			<template v-else-if="menu.name.indexOf('_gmqm') > -1">
				<el-submenu v-bind:index="menu.name" v-bind:key="menu.id">
					<template slot="title">
						<i v-bind:class="menu.meta.icon"></i>
						<span v-text="menu.meta.title"></span>
					</template>
					<el-menu-item v-for="child in menu.children" v-bind:index="child.name" v-text="child.meta.title" v-bind:key="child.id"></el-menu-item>
				</el-submenu>
			</template>
		</template>
	</el-menu>
</template>

<script>
	import { mapState, mapActions } from 'vuex'
	import permissionService from '@/service/permissionService'
	export default {
		data() {
			return {
				tree: [],
				isCollapse: false,
				
			}
		},
		computed: {
			pathRouter(){
			   return this.$route.name
			} ,
			
			...mapState({
				// 后台菜单
				permissionMenuList: state => state.user.permissionList,
			}),
		},
		methods: {
			handleSelect(key) {
				if (key == 'signout') {
					// 到登录页重新获取token
					localStorage.removeItem('token')
					this.$router.replace({
						path: '/login',
					})
				} else if (key == 'changeCollapse') {
					this.isCollapse = !this.isCollapse
					this.$emit('changeCollapse', this.isCollapse)
				} else {
					//var new_name=key.replace("")
					this.$router.push({ name: key }).catch(err => {
						err
					})
				}
			},
			handleOpen(key, keyPath) {
				console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
            console.log(key, keyPath);
            }
		},
		created() {
			//加载菜单。
			this.tree = this.permissionMenuList
			this.$emit('changeCollapse', this.isCollapse)
		},
	}
</script>
<style lang="less" scoped>
	.el-menu-vertical:not(.el-menu--collapse) {
		width: 250px;
		min-height: 400px;
	}

	.el-menu {
		border-right: none;
	}

	.el-menu-item i {
		color: #dd0010;
	}

	.el-menu-item.is-active {
		color: #d90010;
	}

	.el-submenu__title i {
		color: #d90010;
	}

	.collapse {
		border-bottom: 1px solid rgb(238, 238, 238);
	}

	.collapse:hover {
		background-color: #eee;
	}

	.collapse i {
		color: #333;
	}
</style>
